var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeaserInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4160_81621)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 43,
    width: 12,
    height: 12,
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 43,
    width: 110,
    height: 12,
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 71,
    width: 160,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 95,
    width: 160,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 119,
    width: 160,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 54.1262C97.8884 53.9215 99.0687 53.5752 99.5408 53.0871C100.013 52.5833 100.249 51.2844 100.249 49.1904V28.2428C100.249 26.5109 99.9814 25.3852 99.4464 24.8657C98.927 24.3461 97.7783 24.0234 96 23.8974V23H109.431V23.8974C107.653 24.0234 106.496 24.3461 105.961 24.8657C105.426 25.3852 105.159 26.5109 105.159 28.2428V37.6657H119.818V28.2428C119.818 26.5109 119.558 25.3852 119.039 24.8657C118.519 24.3461 117.363 24.0234 115.569 23.8974V23H129V23.8974C127.222 24.0234 126.065 24.3461 125.53 24.8657C125.011 25.3852 124.751 26.5109 124.751 28.2428V49.7572C124.751 51.5205 125.011 52.6541 125.53 53.1579C126.065 53.646 127.222 53.9688 129 54.1262V55H115.569V54.1262C117.473 53.9373 118.653 53.5909 119.109 53.0871C119.582 52.5833 119.818 51.2844 119.818 49.1904V39.7911H105.159V49.7572C105.159 51.5205 105.426 52.6541 105.961 53.1579C106.496 53.6617 107.653 53.9845 109.431 54.1262V55H96V54.1262Z",
    fill: "#4C6170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.453 75.052L144.931 74.0002L147.273 78.0088L170 116.916L171.51 119.5L173.32 117.116L180.116 108.168L197.088 120.613L198.674 121.776L199.863 120.21L205.593 112.666L206.823 111.046L205.183 109.844L188.265 97.4391L195.021 88.5447L196.888 86.0864L193.881 85.387L149.453 75.052Z",
    fill: "white",
    stroke: "#4C6170",
    strokeWidth: 4
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#FFB60A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4160_81621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 117,
    fill: "white",
    transform: "translate(80 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeaserInfo);
export default __webpack_public_path__ + "static/media/teaser-info.b7b0ba750ae6c5e699304d9e4b2f0472.svg";
export { ForwardRef as ReactComponent };